<template>
	<div v-if="isUserModal">
		<div class="overlay" @click="closeModal"></div>
		<section class="user-modal">

			<div @click="closeModal" class="close_icon"></div>

			<form @submit.prevent="addUser(user, isExist)" class="entry_form">
				<div class="form-group">
					<label>Номер телефона
						<input-phone :user="user" :search="searchUser"></input-phone>
					</label>
				</div>

				<label>Фамилия
					<input type="text" v-model="user.last_name" :disabled="isExist" required/>
				</label>

				<label>Имя
					<input type="text" v-model="user.first_name" :disabled="isExist" required/>
				</label>

				<label>Отчество
					<input type="text" v-model="user.middle_name" :disabled="isExist" required/>
				</label>

				<label v-if="isStaff">Должность
					<select id="role" title="roles" v-model="user.role_id" required>
						<option v-for="role in roles" :value="role._id">{{role.name}}</option>
					</select>
				</label>

				<label>Пол
					<select v-model="user.sex" :disabled="isExist" required>
						<option value="male">Мужской</option>
						<option value="female">Женский</option>
					</select>
				</label>

				<label>Дата рождения
					<input type="text" v-model="user.birthday" v-mask="'##-##-####'" :disabled="isExist" required/>
				</label>

				<input class="entry_button" type="submit" value="Добавить">
			</form>
		</section>
	</div>
</template>

<script>
	import InputPhone from '@/components/InputPhone.vue'
	import moment from 'moment'

	export default {
		name: 'StaffModal',
		components: {InputPhone},
		computed: {
			clinicId() {
				return this.$route.query.clinic
			}
		},
		mounted() {
			this.$event.connect('openStaffModal', (user) => {
				this.isUserModal = true

				if(user._id) {
					this.user = user
					this.isExist = true
				} else {
					this.user = {
						phone: '',
						birthday: ''
					}
				}
			})

			this.$event.connect('closeStaffModal', () => {
				this.closeModal()
			})

			this.$api.get('role/all/get').then(response => {
				this.roles = response
			})
		},
		beforeDestroy() {
			this.$event.disconnect(['openStaffModal', 'closeStaffModal'])
		},
		data() {
			return {
				isUserModal: false,
				user: {
					phone: '',
					birthday: ''
				},
				isExist: false,
				roles: [],
				block: false,
				isStaff: true
			}
		},
		methods: {
			addUser(user, isExist) {
				if(isExist) {
					this.addStaff(user)
				} else {
					this.createUser(user)
				}
			},
			createUser(user, type) {
				user.verified = true
				user.status = 'created'
				user.birthday = moment(user.birthday, "DD-MM-YYYY").format('X')

				this.$api.post('user/', user).then((response) => {
					response.role_id = user.role_id
					this.addStaff(response, type)
				})
			},
			addStaff(user) {
				this.$api.post('worker/', {
					user_id: user._id,
					clinic_id: this.clinicId,
					role_id: user.role_id,
					time: 5,
					status: 'created',
					can: 'no',
					specializations: ''
				}).then(staff => {
					this.closeModal()

					this.$router.push({
						path: 'profile',
						query: {
							doctor: staff._id,
							clinic: this.clinicId
						}
					})
				})
			},
			searchUser(phone) {
				this.isExist = false

				if(phone.length < 12)
					return false

				this.$api.get('user/by-phone/' + phone).then((response) => {
					if(response._id) {
						this.user = response
						this.user.role_id = (response.role) ? response.role._id : ''
						this.user.birthday = moment(this.user.birthday, 'X').format('DD-MM-YYYY')
					} else {
						this.$event.toast('i', 'Пользователь не найден')
						this.user = {
							phone: phone,
							birthday: ''
						}
					}

					this.isExist = Boolean(response._id)
				})
			},
			fill() {
				if(!this.user.phone)
					this.user.phone = '380'
			},
			clean() {
				if(this.user.phone === '380')
					this.user.phone = ''
			},
			closeModal() {
				this.isUserModal = false
				this.user = {
					phone: '',
					birthday: ''
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// StaffModal.vue?7746dd1a